export const getCountryFromCoords = async (latitude, longitude) => {
  const response = await fetch(
    `https://nominatim.openstreetmap.org/reverse?lat=${latitude}&lon=${longitude}&format=json`
  )
  const data = await response.json()
  return data.address.country.toLowerCase()
}
